var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3",attrs:{"id":"markdownBody"}})
}
var staticRenderFns = []

export { render, staticRenderFns }